// extracted by mini-css-extract-plugin
module.exports = {"box":"history_box__1Cjn9","list":"history_list__2FKDe","placeHolder":"history_placeHolder__1SzZS"};